import React from 'react';
import Button from '@components/ui/Button';
import { PHONE_NUMBER, PHONE_NUMBER_TEL } from '@utils/constants';

interface ContactSectionProps {
  onRequestQuoteClick: () => void;
}

const ContactSection: React.FC<ContactSectionProps> = ({ onRequestQuoteClick }) => {
  return (
    <section id="contact" className="py-12 bg-sky-600 text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Book?</h2>
          <p className="text-xl mb-8 text-sky-100">Call now or request a quote online</p>

          <div className="bg-white/10 rounded-lg p-6 max-w-md mx-auto">
            <h3 className="text-xl font-semibold mb-4">Call Us</h3>
            <a href={PHONE_NUMBER_TEL} className="text-3xl font-bold hover:text-sky-100">
              {PHONE_NUMBER}
            </a>
            <p className="mt-2 text-sky-100">Available 7 days a week</p>
          </div>

          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button variant="white" size="lg" onClick={onRequestQuoteClick}>
              Request Quote
            </Button>
            <Button variant="outline" size="lg">
              View Calendar
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;